import { createSlice } from "@reduxjs/toolkit";
import { API_STATUSES } from "redux/_helpers/statuses";

const peopleReducers = createSlice({
  name: "peopleReducers",
  initialState: {
    getAllPeopleStatus: API_STATUSES.REQUEST,
    getAllPeopleData: [],
    getPeopleStatus: API_STATUSES.REQUEST,
    getPeopleData: []
  },

  reducers: {  
    getAllPeopleStatus: (state, action) => {
      state.getAllPeopleStatus = action.payload;
    },
    getAllPeopleData: (state, action) => {
      state.getAllPeopleData = action.payload;
    },
    getPeopleStatus: (state, action) => {
      state.getPeopleStatus = action.payload;
    },
    getPeopleData: (state, action) => {
      state.getPeopleData = action.payload;
    },
    getGroupsStatus: (state, action) => {
      state.getGroupsStatus = action.payload;
    },
    getGroupsData: (state, action) => {
      state.getGroupsData = action.payload;
    },
    savePersonStatus: (state, action) => {
      state.savePersonStatus = action.payload;
    },
    savePersonData: (state, action) => {
      state.savePersonData = action.payload;
    },
    getRfidAccessLevelStatus: (state, action) => {
      state.getRfidAccessLevelStatus = action.payload;
    },
    getRfidAccessLevelData: (state, action) => {
      state.getRfidAccessLevelData = action.payload;
    },
    editPersonStatus: (state, action) => {
      state.editPersonStatus = action.payload;
    },
    editPersonData: (state, action) => {
      state.editPersonData = action.payload;
    },
    saveRfidStatus: (state, action) => {
      state.saveRfidStatus = action.payload;
    },
    saveRfidData: (state, action) => {
      state.saveRfidData = action.payload;
    },
    updateRfidStatus: (state, action) => {
      state.updateRfidStatus = action.payload;
    },
    updateRfidData: (state, action) => {
      state.updateRfidData = action.payload;
    },
    getRFIDByTagStatus: (state, action) => {
      state.getRFIDByTagStatus = action.payload;
    },
    getRFIDByTagData: (state, action) => {
      state.getRFIDByTagData = action.payload;
    },
    deleteRfidByTagStatus: (state, action) => {
      state.deleteRfidByTagStatus = action.payload;
    },
    deleteRfidByTagData: (state, action) => {
      state.deleteRfidByTagData = action.payload;
    },
    transferRfidStatus: (state, action) => {
      state.transferRfidStatus = action.payload;
    },
    transferRfidData: (state, action) => {
      state.transferRfidData = action.payload;
    },
    assignNewRfidStatus: (state, action) => {
      state.assignNewRfidStatus = action.payload;
    },
    assignNewRfidData: (state, action) => {
      state.assignNewRfidData = action.payload;
    }
  },
});

export const {
    getAllPeopleStatus,
    getAllPeopleData,
    getPeopleStatus,
    getPeopleData,
    getGroupsStatus,
    getGroupsData,
    savePersonStatus,
    savePersonData,
    getRfidAccessLevelStatus,
    getRfidAccessLevelData,
    editPersonStatus,
    editPersonData,
    saveRfidStatus,
    saveRfidData,
    updateRfidStatus,
    updateRfidData,
    getRFIDByTagStatus,
    getRFIDByTagData,
    deleteRfidByTagStatus,
    deleteRfidByTagData,
    transferRfidStatus,
    transferRfidData,
    assignNewRfidStatus,
    assignNewRfidData
} = peopleReducers.actions;

export default peopleReducers.reducer;
